(function() {
  function rbAdjustGifts(onDone) {
    var bar = document.querySelector('.rewards-bar[data-gift1-threshold],.rewards-bar[data-gift2-threshold],.rewards-bar[data-gift3-threshold]');
    if (!bar) { onDone(false); return; }
    var gifts = [];
    ['1','2','3'].forEach(function(n) {
      var t = bar.getAttribute('data-gift'+n+'-threshold');
      var v = bar.getAttribute('data-gift'+n+'-variant');
      var p = bar.getAttribute('data-gift'+n+'-product');
      if (t && v && p) gifts.push({ threshold: +t, variantId: +v, productId: +p });
    });
    if (!gifts.length) { onDone(false); return; }
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var giftAdj = 0;
      cart.items.forEach(function(it) {
        if ((it.properties||{})._free_gift === '1') giftAdj += it.final_line_price;
      });
      var eff = cart.total_price - giftAdj;
      var ops = [];
      gifts.forEach(function(g) {
        var shouldHave = eff >= g.threshold, cartItem = null;
        cart.items.forEach(function(it) {
          if (it.product_id === g.productId && (it.properties||{})._free_gift === '1') cartItem = it;
        });
        if (shouldHave && !cartItem) ops.push({ type: 'add', variantId: g.variantId });
        else if (!shouldHave && cartItem) ops.push({ type: 'remove', key: cartItem.key });
      });
      if (!ops.length) { onDone(false); return; }
      var chain = Promise.resolve();
      ops.forEach(function(op) {
        chain = chain.then(function() {
          if (op.type === 'add') {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: op.variantId, quantity: 1, properties: { _free_gift: '1' } }] })
            });
          } else {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: op.key, quantity: 0 })
            });
          }
        });
      });
      chain.then(function() { onDone(true); }).catch(function() { onDone(false); });
    }).catch(function() { onDone(false); });
  }

  if (!window._rbFetchPatched) {
    window._rbFetchPatched = true;
    var _rbOrigFetch = window.fetch;
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      var isCartMod = /\/cart\/(add|change|update)\.js/.test(url);
      if (!isCartMod || window._rbGiftFetching) {
        return _rbOrigFetch.apply(this, arguments);
      }
      return _rbOrigFetch.apply(this, arguments).then(function(response) {
        if (!response.ok) return response;
        var forCaller = response.clone();
        window._rbGiftFetching = true;
        return new Promise(function(resolve) {
          rbAdjustGifts(function(hadOps) {
            window._rbGiftFetching = false;
            if (hadOps) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: { scrollToTop: false }
              }));
            }
            resolve(forCaller);
          });
        });
      });
    };
  }

  document.addEventListener('DOMContentLoaded', function() {
    window._rbGiftFetching = true;
    rbAdjustGifts(function(hadOps) {
      window._rbGiftFetching = false;
      if (hadOps) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { scrollToTop: false }
        }));
      }
    });
  });

  document.documentElement.addEventListener('cart:rerendered', function() {
    if (window.rbFixOverlap) window.rbFixOverlap();
  }, true);

  /* ── Seitensperre für den Warenkorb-Drawer ─────────────────────────────────
     Solange der Mini-Cart offen ist, darf die Seite dahinter nicht mitscrollen.

     Warum hier und nicht in sections/mini-cart.liquid: Das dortige <script>
     liegt innerhalb von <form id="mini-cart">, und dieses Formular wird vom
     Theme in den Header verschoben. Der Header wird per innerHTML aufgebaut –
     dabei führt der Browser Skripte grundsätzlich nicht aus. Jeder Code in
     dieser Section ist damit wirkungslos; das CSS greift weiterhin.

     Die passenden Regeln (html.cart-drawer-open) stehen in
     sections/mini-cart.liquid. Hier wird nur die Klasse gesetzt.

     Beobachtet wird dokumentweit auf aria-hidden, weil der Drawer-Knoten bei
     jedem Section-Neuaufbau ersetzt wird – ein Observer direkt am Knoten würde
     das nicht überleben. */
  var psDrawerScrollY = 0;

  function psSetCartDrawerOpen(isOpen) {
    var html = document.documentElement;
    if (isOpen === html.classList.contains('cart-drawer-open')) return;

    if (isOpen) {
      psDrawerScrollY = window.pageYOffset || html.scrollTop || 0;
      html.classList.add('cart-drawer-open');
      document.body.classList.add('cart-drawer-open');
      /* Die Sperre setzt position:fixed. Ohne diesen Versatz würde die Seite
         hinter dem Drawer nach oben springen. */
      document.body.style.top = (-psDrawerScrollY) + 'px';
    } else {
      html.classList.remove('cart-drawer-open');
      document.body.classList.remove('cart-drawer-open');
      document.body.style.top = '';
      window.scrollTo(0, psDrawerScrollY);
    }
  }

  new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var ziel = mutations[i].target;
      if (ziel && ziel.id === 'mini-cart') {
        psSetCartDrawerOpen(ziel.getAttribute('aria-hidden') !== 'true');
      }
    }
  }).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
  });
})();
